import List from "@/components/list";
import Bus from "./Bus.js";
import router from "@/router";
// import { noticeDel } from "@/api/notice";
// import "./table.css";

const Table = args => {
  const { listeners } = args;
  const RCSelectionChange = args.listeners["selection-change"] || function () { };
  const handleShare = listeners["handleShare"] || function () { };
  const deptLevelCode = args.props.deptLevelCode;

  function deleteNotice(data) {
    Bus.$emit("deleteNotice", data);
  }
  function setUp(data, type) {
    Bus.$emit("setUp", { id: data, status: type });
  }
  function setDown(data, type) {
    Bus.$emit("setUp", { id: data, status: type });
  }
  /* function setTop(data, type) {
    Bus.$emit("setTop", { id: data, status: type });
  }*/
  function editNotice(data) {
    router.push({
      path: "/news/editNews",
      query: {
        newsDetail: data
      }
    });
  }

  const Deal = ({ props: { vo } }) => {
    let isMyCollege = vo.row.originDeptLevelCode == deptLevelCode;
    let canShare = vo.row.canShare;
    let canUpdate = vo.row.canUpdate;
    const user = vo.row;
    let dealConf = [];

    if (user.onlineStatus == 1) {
      dealConf.push(["icon-edit-disable", "修改", () => { }, "news:update"])
      dealConf.push(["icon-delete-disable", "删除", () => { }, "news:delete"])
      dealConf.push([
        "icon-down",
        "下线",
        () => setDown(user.uuid, 0),
        "news:online"
      ]);
    } else {
      if (canUpdate) {
        // 版权方为本学院 && 下线状态
        dealConf.push(["icon-edit", "修改", () => editNotice(user), "news:update"])
      } else {
        dealConf.push(["icon-edit-disable", "修改", () => { }, "news:update"]);
      }
      // dealConf.push(["icon-edit", "修改", () => editNotice(user), "news:update"])
      dealConf.push(["icon-delete", "删除", () => deleteNotice(user.uuid), "news:delete"])
      dealConf.push([
        "icon-up",
        "上线",
        () => setUp(user.uuid, 1),
        "news:online"
      ]);
    }

    if (canShare){
      dealConf.push(["icon-share", "共享管理", () => handleShare(vo.row), "news:share"]);
    } else {
      dealConf.push(["icon-share-none", "共享管理", () => {}, "news:share"]);
    }

    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip
            class="item"
            effect="dark"
            content={item[1]}
            placement="top"
            v-permission={item[3]}
          >
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };
  const NewsTitle = ({ props: { vo } }) => {
    return (
      <div
        class="base-hover-char"
        onClick={() => {
          router.push({
            path: "/news/detail",
            query: {
              newsDetail: vo.row
            }
          })
        }}
      >
        {vo.row.newsTitle}
      </div>
    );
  };

  // function selectable(row, index) {
  //   return row.canShare == 1;
  // }

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main",
      // selectable: selectable
    },
    {
      label: "新闻标题",
      prop: "newsTitle",
      minWidth: "100",
      showOverflowTooltip: true,
      render: vo => <NewsTitle vo={vo} />
    },
    {
      label: "类型",
      prop: "newsTypeName",
      minWidth: "100",
      showOverflowTooltip: true
    },
    {
      label: "状态",
      prop: "onlineStatusName",
      minWidth: "100"
    },
    {
      label: "来源",
      prop: "newsSource",
      minWidth: "100",
      showOverflowTooltip: true
    },
    {
      label: "作者",
      prop: "newsAuthor",
      minWidth: "100",
      showOverflowTooltip: true
    },
    {
      label: "发布单位",
      prop: "deptName",
      minWidth: "100",
      showOverflowTooltip: true
    },
    {
      label: "版权方",
      prop: "originDeptName",
      width: "100",
      showOverflowTooltip: true,
    },
    {
      label: "已共享学院",
      prop: "sharedDeptNames",
      width: "150",
      showOverflowTooltip: true,
    },
    {
      label: "最后更新",
      prop: "modifyDate",
      minWidth: "100",
      showOverflowTooltip: true
    },
    {
      label: "点击量",
      prop: "clicks",
      minWidth: "100",
      showOverflowTooltip: true
    },
    /*{
      label: "是否置顶",
      prop: "setTopName",
      minWidth: "100",
      showOverflowTooltip: true
    },*/
    // {
    //   label: "调动状态",
    //   prop: "userStatus",
    //   minWidth: "100"
    // },
    {
      label: "操作",
      minWidth: "160",
      fixed: "right",
      render: vo => <Deal vo={vo} />
    }
  ];

  return (
    <List
      {...args}
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
